/**
 * Hooks from react-use
 */

/**
 * Hooks from react-use
 */
// https://github.com/streamich/react-use/blob/master/docs/useHover.md
import useHover from 'react-use/lib/useHover';

// https://github.com/streamich/react-use/blob/master/docs/useClickAway.md
import useClickAway from 'react-use/lib/useClickAway';

// https://github.com/streamich/react-use/blob/master/docs/useHover.md
import useHoverDirty from 'react-use/lib/useHoverDirty';

// https://github.com/streamich/react-use/blob/master/docs/useCopyToClipboard.md
import useCopyToClipboard from 'react-use/lib/useCopyToClipboard';

// https://github.com/streamich/react-use/blob/master/docs/useTimeoutFn.md
import useTimeoutFn from 'react-use/lib/useTimeoutFn';

// https://github.com/streamich/react-use/blob/master/docs/useUnmount.md
import useUnmount from 'react-use/lib/useUnmount';

// https://github.com/streamich/react-use/blob/master/docs/useMountedState.md
import useMountedState from 'react-use/lib/useMountedState';

// https://github.com/streamich/react-use/blob/master/docs/useIntersection.md
import useIntersection from 'react-use/lib/useIntersection';

// https://github.com/streamich/react-use/blob/master/docs/useMeasure.md
import useMeasure from 'react-use/lib/useMeasure';

// https://github.com/streamich/react-use/blob/master/docs/useWindowScroll.md
import useWindowScroll from 'react-use/lib/useWindowScroll';

// https://github.com/streamich/react-use/blob/master/docs/useWindowSize.md
import useWindowSize from 'react-use/lib/useWindowSize';

// https://github.com/streamich/react-use/blob/master/docs/useInterval.md
import useInterval from 'react-use/lib/useInterval';

export {
  useClickAway,
  useCopyToClipboard,
  useHover,
  useHoverDirty,
  useIntersection,
  useMeasure,
  useMountedState,
  useTimeoutFn,
  useUnmount,
  useWindowScroll,
  useWindowSize,
  useInterval,
};

/**
 * Custom hooks
 */

export * from './use-popout';
export { useAsyncSafeState } from './use-async-safe-set-state';
export { useMounted } from './use-mounted';
export { useModal } from './use-modal';
export { useFileUploader, type UploadProgress } from './use-file-uploader';
export { useDebounce } from './use-debounce';
export { useToggle } from './use-toggle';
export { usePagination } from './use-pagination';
export { useEffectOnce } from './use-effect-once';
export { usePlans, type Plan } from './use-plans';

export { useKeyPress } from './use-key-press';
export type { IUseKeyPressProps, IUseKeyPress } from './use-key-press';
